
/*
 * VNCtask : VNCtask – the easy to use Task Management & To-Do List application. Stay organized. Anytime! Anywhere!
 * Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, version 3 of the License.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. Look for COPYING file in the top folder.
 * If not, see http://www.gnu.org/licenses/.
 */

import { Component, OnInit, forwardRef, ChangeDetectionStrategy, ChangeDetectorRef } from "@angular/core";
import { TaskOptionComponent } from "../task-option.component";
import { TaskRepository } from "../../../../repository/task.repository";
import { MatDialog } from "@angular/material/dialog";

@Component({
  selector: "vp-vnctask-option-add-estimate",
  providers: [{
    provide: TaskOptionComponent,
    // eslint-disable-next-line
    useExisting: forwardRef(() => TaskAddEstimateComponent)
  }],
  templateUrl: "options-add-estimate.html",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TaskAddEstimateComponent extends TaskOptionComponent implements OnInit {
  id: string = "add-estimate";
  triggerKey: string = "\"";
  estimatedHours: string = "00";
  estimatedMinutes: string = "00";
  estimate: any = {
    name: "estimate",
    value: ""
  };

  constructor(
    private taskRepo: TaskRepository,
    public changerDetectorRef: ChangeDetectorRef,
    public matDialog: MatDialog
  ) {
    super(changerDetectorRef, matDialog);
  }

  ngOnInit() { }

  getPayload() {
    let value = this.getValue();
    if (!value || (value && !value.value)) return {};
    return { "estimated_hours": value.value };
  }

  setEstimatedTime() {
    let value = this.estimatedHours + ":" + this.estimatedMinutes;
    this.estimatedHours = this.estimatedHours !== "" ? this.estimatedHours : "00";
    this.estimatedMinutes = this.estimatedMinutes !== "" ? this.estimatedMinutes : "00";
    this.estimate.value = this.estimate.name = this.estimatedHours + ":" + this.estimatedMinutes;
    this.onDescriptionClick(this.estimate);
    this.estimatedHours = this.estimatedMinutes = "00";
  }

  close() {
    this.estimatedHours = this.estimatedMinutes = "00";
    this.goBack();
  }

  validateNumber(event, ele) {
    if (ele.toString().length > 2) {
      return false;
    }
    let key = window.event ? event.keyCode : event.which;
    if ((event.keyCode > 47 && event.keyCode < 58) ||
      (event.keyCode > 95 && event.keyCode < 106) ||
      event.keyCode === 46 || event.keyCode === 8 ||
      event.keyCode === 9 || event.keyCode === 37 ||
      event.keyCode === 39 || event.keyCode === 13) {
      return true;
    } else if (key < 48 || key > 57) {
      return false;
    } else {
      return true;
    }
  }
}
